import {ActionTree} from 'vuex'
import {WidgetState} from "../models/store-viewmodel"
import services from "@/apps/MyStudyChoiceHeartWidget/services"
import {AxiosResponse} from "axios"
import {
    MyStudychoiceheartNotificationService
} from "@/apps/MyStudyChoiceHeartWidget/services/my-studychoiceheart-notification-service"
import {useAuthenticationExchangeBus} from "@/shared/composables/authenticationExchangeBus"
import {useOnboardingExchangeBus} from "@/shared/composables/onboardingExchangeBus";

export default <ActionTree<WidgetState, any>>{
    setConfig(context, payload) {
        context.commit('setConfig', payload)
    },
    checkIsStudyChoiceStudyFavorite(context) {
        let config = context.getters.config
        context.commit('setInnerLoading', true)

        services.myStudyChoice.getFavourite(config.language, config.study_code)
            .then((response: AxiosResponse) => {
                if (response.data.length) {
                    context.commit('setIsFavorite', true)
                    context.commit('setFavoriteId', response.data[0].id)
                }
            })
            .catch(() => {
                context.commit('root/setErrors', ['Something went wrong retrieving your favorite studies'])
                context.commit('setInnerLoading', false)
            })
            .finally(() => {
                context.commit('setInnerLoading', false)
            })

    },
    setStudyChoiceFavorite(context) {
        let config = context.getters.config
        let notificationService = new MyStudychoiceheartNotificationService();
        services.myStudyChoice.setFavourite(config.language, config.study_code)
            .then((response: AxiosResponse) => {
                if (response.data && response.data.id) {
                    context.commit('setIsFavorite', true);
                    context.commit('setFavoriteId', response.data.id);
                    notificationService.handleSuccess();
                }
            })
            .catch((error: AxiosResponse) => {
                if (error.status === 401) {
                    useAuthenticationExchangeBus().favoriteStudyCode = config.study_code;
                    useAuthenticationExchangeBus().active = true;
                } else if (error.status === 403) {
                    useOnboardingExchangeBus().active = true
                } else {
                    if (!notificationService.handleErrorStatusCodes(error.status)) {
                        context.commit('root/setErrors', ['Something went wrong retrieving your favorite studies'])
                    }
                }
            })
    },
    deleteStudyChoiceFavorite(context) {
        let favoriteId = context.getters.favoriteId

        services.myStudyChoice.deleteFavourite(favoriteId)
            .then(() => {
                context.commit('setIsFavorite', false)
            })
            .catch((error: AxiosResponse) => {
                let notificationService = new MyStudychoiceheartNotificationService();
                if (!notificationService.handleErrorStatusCodes(error.status)) {
                    context.commit('root/setErrors', ['Something went wrong retrieving your favorite studies'])
                    context.commit('setInnerLoading', false)
                }
            })
    }
}
